var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGreaterThanOrEqualTo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "greater than or equal to",
  d: "M1.5 1.85 2.13 0 12.5 4.39v1.92L2.13 10.7 1.5 8.86 10 5.35Zm0 10.25h11V14h-11Z"
})));
export default SvgGreaterThanOrEqualTo;